import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isPlatformBrowser, PlatformLocation } from '@angular/common';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly TOKEN_KEY = 'auth_token';

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private platformLocation: PlatformLocation) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip token logic on server-side
    if (!isPlatformBrowser(this.platformId)) {
      return next.handle(request);
    }

    // Get token from localStorage (only in browser environment) with error handling
    let token: string | null = null;
    try {
      token = localStorage.getItem(this.TOKEN_KEY);
    } catch (error) {
      console.warn('Failed to access localStorage:', error);
      // Continue without token if localStorage is not available
    }

    // Only modify API requests
    if (token && request.url.includes('/frontend/')) {
      // Only add the Basic auth header for test environments
      if (['localhost', 'test.coinmate.cz'].includes(this.platformLocation.hostname)) {
        // todo: remove hardcoded Basic auth header when not needed, when we are using ZeroTrust, or move to process.env
        request = request.clone({
          setHeaders: {
            Authorization: `Basic bW9iaWxlLWFwcC0yMDI1OlRyb2xsMVJhbmdlNExpYmVyYWw3SW1wZXJhdGl2ZTM=, Bearer ${token}`,
          },
        });
      } else {
        // For non-test environments, only add the Bearer token
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    }

    return next.handle(request);
  }
}
